import React from 'react'
import MenuItem from '@material-ui/core/MenuItem'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  menuItem: {
    whiteSpace: 'normal',
    wordWrap: 'break-word',
  },
}))

const ClusterMenuItem = ({ item, onSelect, isSelected }) => {
  const classes = useStyles()
  return (
    <MenuItem className={classes.menuItem} onClick={() => onSelect(item)} selected={isSelected}>
      {item.nombre}
    </MenuItem>
  )
}

export { ClusterMenuItem }
